import { FilterMatchMode } from "primereact/api";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import {
  convertDateFromTo,
  defaultPageRowOptions,
  defaultRowOptions,
  paginatorLinks,
  showingEntries,
  SkeletonbodyTemplate,
  Skeletonitems,
} from "../../../appconfig/Settings";
import { Column } from "primereact/column";
import { amountTemplate } from "../../../appconfig/TemplateSetting";
import { moneyReceivedCol } from "../../../appconfig/DataTableColumns";
import { getAllDetails } from "../../../service/ProductService";
import { GET_MONEY_RECIEVE_LIST } from "../../../config/ApiConstant";

const MoneyReceivedList = () => {
  document.title = "Money Received List | Agriown";

  // Get User ID From URL
  const { id }: any = useParams();
  // Decode operator ID
  const operator_id = atob(id);

  // /Set Toast/ Filter Properties
  const toast = useRef<Toast>(null);

  const [moneyReceivedList, setMoneyReceivedList] = useState<any>([]);

  // Filter Properties
  const [globalFilter, setGlobalFilter] = useState<any>(null);

  //Loading/Page Loading
  const [pageLoad, setPageLoad] = useState<boolean>(false);

  // datatable filter value sets
  const emptyFilters = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  };
  const [filters, setFilters] = useState(emptyFilters);

  // useEffect to get received amount  list on page load
  useEffect(() => {
    getOperatorBookingList();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [operator_id]);

  //Clear All Filter
  const clearAll = () => {
    setFilters({ ...emptyFilters });
    setGlobalFilter("");
  };

  // api call for get received amount list
  const getOperatorBookingList = async () => {
    try {
      const response = await getAllDetails(
        `${GET_MONEY_RECIEVE_LIST}?operator_id=${operator_id}`
      );

      if (response) {
        setMoneyReceivedList(response);
        setPageLoad(true);
      } else {
        setMoneyReceivedList([]);
        setPageLoad(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
      });
      setPageLoad(false);
    }
  };

  // left toolbar
  const leftToolbarTemplate = () => {
    return (
      <span className="mr-3 search-bar">
        <i className="pi pi-search" />
        <InputText
          type="search"
          className="search-input"
          value={globalFilter}
          onChange={(e) => setGlobalFilter(e.currentTarget.value)}
          placeholder="Search..."
        />
      </span>
    );
  };

  //Clear Filters
  const rightToolbarTemplate = () => {
    return (
      <>
        <Button
          icon="pi pi-filter-slash"
          label="Clear"
          onClick={() => clearAll()}
          className="mr-2 p-button-outlined p-button-primary"
        ></Button>
      </>
    );
  };
  return (
    <>
      <Toast ref={toast} />

      <div className="grid crud-demo">
        <div className="col-12">
          <div className="card">
            <Toolbar
              left={leftToolbarTemplate}
              right={rightToolbarTemplate}
            ></Toolbar>

            {pageLoad ? (
              <DataTable
                value={moneyReceivedList}
                showGridlines
                stripedRows
                globalFilter={globalFilter || null}
                rows={defaultRowOptions}
                paginator={moneyReceivedList.length >= 10}
                rowsPerPageOptions={defaultPageRowOptions}
                className="datatable-responsive p-datatable-sm"
                paginatorTemplate={paginatorLinks}
                currentPageReportTemplate={showingEntries}
                filters={{ ...filters, global: { ...filters.global, value: globalFilter || null } }}
                onFilter={(e: any) => setFilters(e.filters)}
                emptyMessage="No Data Found"
                removableSort
              >
                {moneyReceivedCol.map((col, i) => {
                  if (col.field === "received_amount") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        body={amountTemplate}
                        sortable
                      />
                    );
                  } else if (col.field === "received_date") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        body={convertDateFromTo}
                      />
                    );
                  } else {
                    return (
                      <Column
                        key={col.field}
                        sortable
                        field={col.field}
                        header={col.header}
                      />
                    );
                  }
                })}
              </DataTable>
            ) : (
              <DataTable value={Skeletonitems}>
                {moneyReceivedCol.map((col: any) => (
                  <Column
                    key={col.field}
                    field={col.field}
                    header={col.header}
                    body={SkeletonbodyTemplate}
                  />
                ))}
              </DataTable>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MoneyReceivedList;
